import config from "config/config";
import { PRICING_PLANS_ANCHOR } from "../MenuItems/MenuItems.config";
import type { ActionButtonsConfig } from "./ActionButtons.d";

export const actionButtonsConfig: Array<ActionButtonsConfig> = [
  {
    translationKey: "button_login",
    href: `${config.webappUrl}/plus`,
    variant: "link",
    dataTestId: "top-navbar-login-airhelp-plus",
    color: "primary.900",
  },
  {
    translationKey: "button_join_airhelp_plus",
    href: `#${PRICING_PLANS_ANCHOR}`,
    variant: "primary",
    dataTestId: "top-navbar-join-airhelp-plus",
    color: "white",
  },
];
